export default __webpack_public_path__ + "static/media/PDF.b4fd689d.svg";